import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_CMS_TVCHANNELS,
} from '../../../../../constants/RoleConsts';
import {
  TVCHANNEL_BOUQUETS_EDIT,
  TVCHANNEL_BOUQUETS_TABS,
} from '../../../../../constants/TvChannelsConst';
import DetailViewLayout from '../../../../../shared/detail-view-layout/Detail-View-Layout';
import { getBouquet } from '../../../../../utils/cmsUtils';
import {
  allFloorsSelector,
  allLocationsSelector,
  allRoomsSelector,
} from '../../../../property/propertySlice';
import { bouquetSelector } from '../../../cmsSlice';
import BouquetsDetails from './Bouquets-Details';

const BouquetsView = (props) => {
  const { bouquet, hotelId, toggleDrawer, onViewToggle, permissions } = props;
  const [tabValue, setTabValue] = useState(0);
  const [selectedBouquet, setSelectedBouquet] = useState(bouquet);
  const locationListData = useSelector(allLocationsSelector);
  const roomListData = useSelector(allRoomsSelector);
  const floorListData = useSelector(allFloorsSelector);
  const bouquetList = useSelector(bouquetSelector);

  useEffect(() => {
    const featchBouquet = async () => {
      if (bouquet && bouquetList.length) {
        const bouquetObj = {
          ...bouquetList.find((tempBouquetInfo) => tempBouquetInfo.id === bouquet.id),
        };
        const res = await getBouquet(hotelId, bouquet.id);
        const resBouquet = bouquetObj;
        resBouquet.livetvs = res.data.getBouquet.livetvs;
        let roomlist = [];
        roomlist = (bouquet.room || []).map((item) => {
          const roomData = roomListData.find((room) => (room.id === item ? room.number : null));
          return { ...item, name: roomData ? roomData.number : null };
        });
        resBouquet.bouquetRooms = roomlist;

        let floorlist = [];
        floorlist = (bouquet.floor || []).map((item) => {
          const floorData = floorListData.find((floor) =>
            floor.id === item ? floor.number : null,
          );
          return { ...item, name: floorData ? floorData.number : null };
        });
        resBouquet.bouquetFloors = floorlist;
        let locationlist = [];
        locationlist = (bouquet.location || []).map((item) => {
          const locationData = locationListData.find((loc) => (loc.id === item ? loc.name : null));
          return { ...item, name: locationData ? locationData.name : null };
        });
        resBouquet.bouquetLocations = locationlist;

        setSelectedBouquet(resBouquet);
      }
    };

    featchBouquet();
  }, [bouquet, bouquet.id, bouquetList]);

  const onOpenDrawer = (type) => {
    toggleDrawer(type, true, selectedBouquet);
  };

  const onClickEdit = (event) => {
    onOpenDrawer(TVCHANNEL_BOUQUETS_EDIT);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const renderScreen = () => {
    return <BouquetsDetails tabValue={tabValue} bouquet={selectedBouquet} />;
  };

  return (
    <>
      {selectedBouquet && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          handleTabChange={handleTabChange}
          tabValue={tabValue}
          tabList={TVCHANNEL_BOUQUETS_TABS}
          renderScreen={renderScreen}
          onViewToggle={onViewToggle}
          createdUserId={selectedBouquet.createdBy}
          isEditable={permissions[RBAC_TYPE_CMS_TVCHANNELS] === RBAC_PERMISSION_LEVEL_FULL_ACCESS}
          isHeightIncluded={true}
          title={selectedBouquet.name}
          tabClass='col-md-3'
        />
      )}
    </>
  );
};

export default BouquetsView;
